// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {Timestamp} from '@wandb/weave/components/Timestamp';
import React from 'react';
import {Link} from 'react-router-dom';
import {CellInfo} from 'react-table';

import NoAccessPage from '../../../pages/NoAccessPage';
import {useViewer} from '../../../state/viewer/hooks';
import {agent as agentUrl} from '../../../util/urls';
import {Queue} from '../Queues/queueUtil';
import {Table} from '../Table';
import {AgentStatus} from './AgentStatus';
import * as S from './TabAgents.styles';
import {isPublicQueue, viewerCanSeePublicQueueAdminTabs} from './tabUtil';
import {ZeroAgents} from './ZeroAgents';

type TabAgentsProps = {
  queue: Queue;
  onAddAgent: () => void;
};

export const TabAgents = ({queue, onAddAgent}: TabAgentsProps) => {
  const viewer = useViewer();

  if (isPublicQueue(queue) && !viewerCanSeePublicQueueAdminTabs(viewer)) {
    return <NoAccessPage contentKey={'loggedIn'} />;
  }

  const {agents} = queue;
  if (agents.length === 0) {
    return (
      <ZeroAgents onAddAgent={onAddAgent} resourceType={queue.resourceType} />
    );
  }
  const columns = [
    {
      Header: 'Agent ID',
      accessor: 'name',
      Cell: (cellInfo: CellInfo) => {
        const url = agentUrl(
          queue.entityName,
          cellInfo.original.id,
          'overview'
        );
        return <Link to={url}>{cellInfo.value}</Link>;
      },
    },
    {
      Header: 'Status',
      accessor: 'agentStatus',
      Cell: (cellInfo: CellInfo) => {
        return <AgentStatus value={cellInfo.value} />;
      },
    },
    {
      Header: 'Start date',
      accessor: 'createdAt',
      Cell: (cellInfo: CellInfo) => {
        return <Timestamp value={cellInfo.value} />;
      },
    },
    {
      Header: 'Host',
      accessor: 'hostname',
    },
  ];
  const rows = queue.agents.map(agent => ({
    searchString: `${agent.name}|${agent.agentStatus}|${agent.hostname}`,
    row: agent,
  }));

  const defaultSorted = [
    {id: 'agentStatus', desc: true},
    {id: 'createdAt', desc: true},
  ];
  return (
    <>
      <S.ButtonPanel>
        <S.ClearMessage>
          Inactive agents automatically clear after 7 days.
        </S.ClearMessage>
        <Button icon="add-new" variant="secondary" onClick={onAddAgent}>
          Add an agent
        </Button>
      </S.ButtonPanel>
      <Table
        data={rows}
        columns={columns}
        defaultSorted={defaultSorted}
        pageSize={20}
      />
    </>
  );
};
